{{!--
    The template used by Modal gets passed the following object:
    {
        showCancel: Boolean,        // (optional - defaults to true) whether or not to show cancel button(s)
        classes: Array<String>,     // (optional) array of classes to add to the template
        title: String|HTMLString,   // (optional) Title content
        content: String|HTMLString, // (optional) Body content
    }

    The template used by Modal also supports the following two classes:
    js-action--modal-cancel - (optional) whatever element(s) you add this class to will cancel the modal when clicked
    js-element--modal-content - (required) whichever element you add this to becomes the container element for the modal's content. If using a modal content controller (`modalOptions.controller`), this element is passed as the second argument.
 --}}
<div class="modalSneezeGuard {{#if showCancel}}js-action--modal-cancel{{/if}}"></div>
<div class="globalDialog modal_isActive{{#each classes}} {{this}}{{/each}}">
    <div class="globalDialog-hd{{#unless title}} globalDialog-hd_noTitle{{/unless}}">
        {{#if showCancel}}
            <button class="globalDialog_close js-action--modal-cancel" aria-label="Cancel"></button>
        {{/if}}
        {{#if title}}{{{title}}}{{/if}}
    </div>
    <div class="globalDialog-bd js-element--modal-content">
        {{{content}}}
    </div>
</div>
